
import {tApi}from 'tplus-api';

export default class UserApi
{
    /**
   * 检验单据日期是否合法
   * @param {voucherDate} voucherDate
   */
  static async CheckUserLowestDiscount(content) {
    return await tApi({ "content":JSON.stringify(content)}, 'chanjet.RE.INewPos.CheckUserLowestDiscount', false, false);
  }
}